export default {
  overseas: "生产海外版",
  "prod-app": "开放应用",
  "uat-app": "中文UAT环境",
  proOps: "生产中文版",
  "fat-app": "FAT 应用",
  "dev-app": "DEV中英文环境",
  "local-debug": "本地调试",
  devops: "开发运维",
  other: "其他",
  //------------公共主菜单---------begin--------------/
  "app-officialWebsite": "官方网站",
  "app-businessSystem": "中文业务系统",
  "app-businessSystem1": "中文生产环境",
  "app-businessSystem2": "中文UAT环境",
  "app-businessSystem3": "DEV中文版环境",
  "app-businessSystem4": "DEV海外版环境",
  //------------公共主菜单---------end--------------/
  //------------生产应用---------begin--------------/
  // 办公
  "prod-app-work": "办公",
  "prod-app-sevens-office": "Sevens公共网盘",
  "prod-app-sevens-cloud-disk": "Sevens私有云盘(局域网)",
  "prod-app-sevens-oa": "Sevens OA(暂未启用)",
  // 官方网站
  "prod-app-sevens": "Sevens主页",
  "prod-app-pingworth": "品沃主页",
  "prod-app-store": "哇鹅-商家端",
  "prod-app-sensation": "哇鹅-红人端",
  // 业务系统
  "prod-pw-os": "品沃OS",
  "prod-app-whaee-operator": "哇鹅 - Sevens运营账户入口",
  "prod-app-admin": "哇鹅管理后台",
  "prod-app-mms": "MMS (商家运营管理系统)",
  "prod-app-kpa": "KPA (红人关系伙伴助手)",
  "prod-app-cpa": "CPA (内容关系伙伴助手)",
  "prod-app-cs": "CS (渠道系统)",
  "prod-app-fms": "FMS (财务管理系统)",
  "prod-app-dms": "DMS (数字营销系统)",
  "prod-app-dmp": "DMP (数据管理平台)",
  // 文档资料
  "prod-app-word": "文档资料",
  "prod-whaee-word-navigation": "品沃科技-哇鹅文档导航",
  "prod-whaee-data-analyze-navigation": "品沃科技-产研数据分析",
  //------------生产应用---------end--------------/

  //------------海外版---------begin--------------/
  // 文档资料
  "overseas-word": "文档资料 - 办公",
  "overseas-word-navigation": "海外版生产环境飞书文档",
  "overseas-office": "Sevens公共网盘",
  "overseas-cloud-disk": "群晖NAS网盘",
  // PROD环境
  "overseas-app-prod": "海外版生产环境",
  "overseas-app": "哇鹅-商家端",
  "overseas-os": "品沃OS",
  "overseas-console": "哇鹅 - Sevens运营账户入口",
  "overseas-admin": "哇鹅管理后台",
  "overseas-mms": "MMS (商家运营管理系统)",
  "overseas-kpa": "KPA (红人关系伙伴助手)",
  "overseas-cpa": "CPA (内容关系伙伴助手)",
  "overseas-cs": "CS (渠道系统)",
  "overseas-fms": "FMS (财务管理系统)",
  "overseas-dms": "DMS (数字营销系统)",
  "overseas-dmp": "DMP (数据管理平台)",
  "overseas-ex": "异常管理系统",
  //UAT环境
  "overseas-app-index-uat": "海外版UAT环境",
  "overseas-app-uat": "哇鹅-商家端",
  "overseas-os-uat": "品沃OS",
  "overseas-console-uat": "哇鹅 - Sevens运营账户入口",
  "overseas-admin-uat": "哇鹅管理后台",
  "overseas-mms-uat": "MMS (商家运营管理系统)",
  "overseas-kpa-uat": "KPA (红人关系伙伴助手)",
  "overseas-cpa-uat": "CPA (内容关系伙伴助手)",
  "overseas-cs-uat": "CS (渠道系统)",
  "overseas-fms-uat": "FMS (财务管理系统)",
  "overseas-dms-uat": "DMS (数字营销系统)",
  "overseas-dmp-uat": "DMP (数据管理平台)",
  "overseas-ex-uat": "异常管理系统",
  // 应用配置
  "overseas-config": "海外版应用配置",
  "overseas-apollo": "海外版apollo",
  "overseas-nexus": "海外版Nexus-共用中文版Nexus",
  "overseas-xxljob": "海外版Xxl-Job",
  "overseas-grafana": "海外版Grafana",
  // 运维
  "overseas-om": "海外版运维中间件",
  "overseas-Jenkins": "海外版Jenkins",
  "overseas-kibana": "海外版Kibana",
  "overseas-sonarqube": "海外版Sonarqube",
  "overseas-grafana": "海外版Grafana",

  //------------海外版---------end--------------/

  //------------uat应用---------begin--------------/
  // 业务系统
  "uat-pw-os": "品沃OS",
  "uat-pw-exception": "品沃异常管理",
  "uat-app-whaee-operator": "哇鹅 - Sevens运营账户入口",
  "uat-app-admin": "哇鹅管理后台",
  "uat-app-mms": "MMS (商家运营管理系统)",
  "uat-app-kpa": "KPA (红人关系伙伴助手)",
  "uat-app-cpa": "CPA (内容关系伙伴助手)",
  "uat-app-cs": "CS (渠道系统)",
  "uat-app-fms": "FMS (财务管理系统)",
  "uat-app-dms": "DMS (数字营销系统)",
  "uat-app-dmp": "DMP (数据管理平台)",
  // 官方网站
  "uat-app-store": "哇鹅-商家端",
  "uat-app-sensation": "哇鹅-红人端",
  // 旧版哇鹅
  "uat-app-old-whaee": "旧版哇鹅 (2022-05前版本)",
  "uat-app-old-store-index": "旧版商家端 - PC首页",
  "uat-app-old-store-console": "旧版商家端 - 控制台",
  "uat-app-old-store-h5-index": "旧版商家端 - H5首页",
  "uat-app-old-admin": "旧版admin端",
  "uat-app-old-sensation-index": "旧版红人端 - PC首页",
  "uat-app-old-sensation-console": "旧版红人端 - 控制台",
  "uat-app-old-sensation-h5-index": "旧版红人端 - H5首页",
  //------------uat应用---------end--------------/

  //------------生产运维---------begin--------------/
  //操作说明文档
  "proOps-czsm": "运维文档",
  "proOps-fbsq": "发版申请",
  "proOps-gdsh": "工单审核",
  "proOps-item": "运维文档目录",
  //工单审核地址
  "proOps-archery": "工单审核",

  // 运维
  "proOps-operation": "中文生产运维中间件",
  "proOps-kibana": "Kibana",
  "proOps-kiali": "Kiali",
  "proOps-grafana": "Grafana",
  "proOps-prometheus": "Prometheus",
  "proOps-en-kibana": "美国Whaee-job-Kibana",
  // 基础支持
  "proOps-base-support": "中文生产环境应用配置",
  "proOps-apollo": "Apollo",
  "proOps-otter": "Otter",
  "proOps-xxl-job": "XXL-JOB",
  "proOps-es-head": "Elasticsearch-head",
  "proOps-dolphinscheduler": "DolphinScheduler",
  //------------生产运维---------end--------------/

  //------------fat应用---------begin--------------/
  // 业务系统
  "fat-app-whaee-operator": "哇鹅 - Sevens运营账户入口",
  "fat-app-admin": "哇鹅管理后台",
  "fat-app-mms": "MMS (商家运营管理系统)",
  "fat-app-kpa": "KPA (红人关系伙伴助手)",
  "fat-app-cpa": "CPA (内容关系伙伴助手)",
  "fat-app-cs": "CS (渠道系统)",
  "fat-app-fms": "FMS (财务管理系统)",
  "fat-app-dms": "DMS (数字营销系统)",
  "fat-app-dmp": "DMP (数据管理平台)",
  "fat-pw-os": "品沃OS",
  // 官方网站
  "fat-app-store": "哇鹅-商家端",
  "fat-app-sensation": "哇鹅-红人端",
  //------------fat应用---------end--------------/
  //------------dev应用---------begin--------------/
  // 业务系统
  "dev-pw-os": "品沃OS",
  "dev-pw-exception": "品沃异常管理",
  "dev-app-whaee-operator": "哇鹅 - Sevens运营账户入口",
  "dev-app-admin": "哇鹅管理后台",
  "dev-app-mms": "MMS (商家运营管理系统)",
  "dev-app-kpa": "KPA (红人关系伙伴助手)",
  "dev-app-cpa": "CPA (内容关系伙伴助手)",
  "dev-app-cs": "CS (渠道系统)",
  "dev-app-fms": "FMS (财务管理系统)",
  "dev-app-dms": "DMS (数字营销系统)",
  "dev-app-dmp": "DMP (数据管理平台)",
  "dev-rag-bs": "RAG (RAG报告系统)",
  // 官方网站
  "dev-app-sensation": "哇鹅-红人端",
  "dev-app-store": "哇鹅-商家端",
  "dev-whaee-help": "哇鹅帮助中心",
  // 第三方开发者平台
  "dev-app-third-dev-platform": "第三方开发者平台",
  "dev-app-google-dev": "Google开发",
  "dev-app-amazon-attribution": "亚马逊洞察",
  "dev-app-shopify-dev": "Shopify开发",
  "dev-app-tiktok-dev": "TikTok开发",
  "dev-app-facebook-dev": "Facebook开发",
  //------------dev应用---------end--------------/
  //------------local调试---------begin--------------/
  // 后端调试
  "back-debug": "后端调试",
  "local-debug-whaee-v2console": "哇鹅 - 商家端v2控制台",
  //------------local调试---------end--------------/
  //------------开发运维---------begin--------------/
  // 项目管理
  "devops-project-management": "项目管理",
  "devops-pingcode": "PingCode",
  "devops-wiki": "产研知识库",
  "devops-it-library": "品沃IT智库",
  // 产品&UI
  "devops-Product-UI": "产品&UI",
  "devops-yuque": "语雀",
  "devops-ui-link-navigation": "品沃UI设计链接导航",
  "devops-lanhu": "蓝湖",
  "devops-Figma": "Figma",
  // 开发协同
  "devops-collaboration": "开发协同",
  "devops-swagger": "Swagger API (商家端)",
  "devops-yapi": "YApi",
  "devops-GitLab": "GitLab",
  // 部署&运维
  "devops-deploy-operation": "部署&运维",
  "devops-kubesphere": "KubeSphere",
  "devops-kibana": "Kibana",
  "devops-kiali": "Kiali",
  "devops-grafana": "Grafana",
  "devops-prometheus": "Prometheus",
  // 基础支持
  "devops-base-support": "基础支持",
  "devops-apollo": "Apollo",
  "devops-otter": "Otter",
  "dev-xxl-job": "dev-xxl-job",
  "devEN-xxl-job": "devEN-xxl-job",
  "devops-es-head": "Elasticsearch-head",
  "devops-nexus": "Nexus",
  "devops-dolphinscheduler": "dev-DolphinScheduler",
  "devops-LAN": "品沃局域网",
  //------------开发运维---------end--------------/
  //------------其他---------begin--------------/
  // 其他-广告平台
  "other-ads-platform": "广告平台",
  "other-google-ads": "Google广告",
  "other-amazon-ads": "亚马逊广告",
  "other-tiktok-ads": "TikTok广告",
  "other-facebook-ads": "Facebook广告管理",
  // 其他-常用工具
  "other-commonTools": "常用工具",
  "other-online-tools": "在线工具",
  "other-tool": "程序员在线工具",
  "other-json": "JSON在线编辑器",
  "other-img-del-bottom": "在线图片去底",
  "other-img-to-ico": "在线生成ico图标",
  "other-docker-hub": "Docker Hub",
  "other-aliMaven": "阿里Maven仓库",
  "other-apacheMaven": "Apache Maven仓库",
  "other-msdn": "MSDN工具站",
  "other-google-trans": "Google翻译",
  "other-youdao-trans": "有道翻译",
  "other-baidu-trans": "百度翻译",
  "other-ali-iconfont": "阿里巴巴矢量图标库",
  // 其他-服务平台
  "other-servicePlatform": "服务平台",
  "other-aliCloud": "阿里云",
  "other-ali-email": "阿里邮箱",
  "other-QQemail": "腾讯企业邮箱",
  //------------其他---------end--------------/
};



// WEBPACK FOOTER //
// ./src/lang/zh.js